import React from 'react'

import * as socialBlockStyles from './socialBlock.module.scss'
import Youtube from '../images/youtube-play.svg'
import Facebook from '../images/facebook-square.svg'
import Instagram from '../images/instagram.svg'
import Soundcloud from '../images/soundcloud2.svg'
import Pinterest from '../images/pinterest2.svg'
import { OutboundLink } from 'gatsby-plugin-google-gtag'

const SocialBlock = () => {
    return (
        <div className={socialBlockStyles.socialBlock}>
            <h2 className={socialBlockStyles.socialHeading}>Connect</h2>
            <div className={socialBlockStyles.socialIcons}>
                    <OutboundLink href="https://www.pinterest.com/msstephsunshine" aria-label="Pinterest"><Pinterest className={socialBlockStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://www.youtube.com/channel/UCjKLqaZuRg20F46v8yCz4wA" aria-label="YouTube"><Youtube className={socialBlockStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://soundcloud.com/steph-sunshine-2" aria-label="Soundcloud"><Soundcloud className={socialBlockStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://www.instagram.com/msstephsunshine/" aria-label="Instagram"><Instagram className={socialBlockStyles.socialIcon} /></OutboundLink>
                    <OutboundLink href="https://www.facebook.com/MsStephSunshine/" aria-label="Facebook"><Facebook className={socialBlockStyles.socialIcon} /></OutboundLink>
            </div>
        </div>
    )}

    export default SocialBlock